export type HasId<TId extends string | number> = { Id: TId };

/**
 * Helper function to get the Id from an object.
 */
export function getId<TId extends string | number>(item: HasId<TId>) {
    return item.Id;
}

export type HasName = { Name: string };

/**
 * Helper function for drop downs in which the items with self keys.
 */
export function identity<T>(item: T): T {
    return item;
}

/**
 * Helper function to get the Name from an object.
 */
export function getName(item: HasName) {
    return item.Name;
}
